import './WeekPicker.css';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const formatDateRange = (isoDate) => {
  const start = new Date(isoDate + 'T12:00:00');
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const sm = MONTHS[start.getMonth()];
  const em = MONTHS[end.getMonth()];
  const sd = start.getDate();
  const ed = end.getDate();
  const ey = end.getFullYear();
  return sm === em ? `${sm} ${sd}–${ed}, ${ey}` : `${sm} ${sd}–${em} ${ed}, ${ey}`;
};

export default function WeekPicker({ week, startDate, dateRange, onChange, inputClassName, selectClassName, hideDateField }) {
  const cls = inputClassName || selectClassName || 'week-picker-input';

  const computedDateRange = startDate ? formatDateRange(startDate) : (dateRange || '');

  const emit = (newWeek, newStartDate) => {
    const dr = newStartDate ? formatDateRange(newStartDate) : '';
    onChange({
      week: newWeek,
      month: '',
      year: '',
      weekLabel: newWeek ? `Week ${newWeek}` : '',
      dateRange: dr,
      startDate: newStartDate || '',
    });
  };

  const increment = () => {
    const n = (parseInt(week) || 0) + 1;
    emit(String(n), startDate);
  };

  const decrement = () => {
    const n = Math.max(1, (parseInt(week) || 2) - 1);
    emit(String(n), startDate);
  };

  return (
    <div className="week-picker">
      <div className={hideDateField ? '' : 'week-picker-row'}>
        <div className="week-picker-field">
          <label className="week-picker-label">Week Number</label>
          <div className="week-picker-number-wrap">
            <input
              type="number"
              min="1"
              className={`week-picker-input week-picker-number ${cls !== 'week-picker-input' ? cls : ''}`}
              value={week || ''}
              placeholder="e.g. 10"
              onChange={(e) => emit(e.target.value, startDate)}
            />
            <div className="week-picker-spinners">
              <button type="button" className="week-picker-spin" onClick={increment}>
                <img src="/assets/images/arrow-up-icon.png" alt="increase" className="week-picker-spin-icon" />
              </button>
              <button type="button" className="week-picker-spin" onClick={decrement}>
                <img src="/assets/images/arrow-down-icon.png" alt="decrease" className="week-picker-spin-icon" />
              </button>
            </div>
          </div>
        </div>

        {!hideDateField && (
          <div className="week-picker-field">
            <label className="week-picker-label">Week Start Date</label>
            <input
              type="date"
              className={`week-picker-input week-picker-date ${cls !== 'week-picker-input' ? cls : ''}`}
              value={startDate || ''}
              onChange={(e) => emit(week, e.target.value)}
            />
          </div>
        )}
      </div>

      {week && (
        <p className="week-picker-preview">
          <strong>{`Week ${week}`}</strong>
          {computedDateRange ? ` · ${computedDateRange}` : ''}
        </p>
      )}
    </div>
  );
}
